export class DeviceAuthenticationRequest {
  socketId: string;
  code: string;
  userCode: string;
}

export class CreateAccessTokenRequest {
  code: string;
}

export class CreateAccessTokenResponse {
  accessToken: string;
}

export class CreateDeviceSessionFromExchangeTokenRequest {
  exchangeToken: string;
}
